module.exports = __webpack_public_path__ + "static/media/mirela.1f2ee710.jpeg";